import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=24235312&scoped=true"
import script from "./SidebarLayout.vue?vue&type=script&lang=ts"
export * from "./SidebarLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24235312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24235312')) {
      api.createRecord('24235312', component.options)
    } else {
      api.reload('24235312', component.options)
    }
    module.hot.accept("./SidebarLayout.vue?vue&type=template&id=24235312&scoped=true", function () {
      api.rerender('24235312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/SidebarLayout.vue"
export default component.exports